export default __webpack_public_path__ + "static/media/000_intro_part1.vp9.78c62d06.webm";